import React from "react";
import "../fashion-theme.css";
import "./tillV4.css";

const STEPS = ["Count cash", "Check payments", "Close"];

const BackIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

// Close-till stepper: 1 Count cash · 2 Check payments · 3 Close.
export const FashionTillStepper = ({ active }) => (
  <ol className="ftill-stepper" aria-label="Close till steps">
    {STEPS.map((label, i) => {
      const step = i + 1;
      const state = step < active ? "done" : step === active ? "active" : "todo";
      return (
        <li key={label} className={`ftill-stepper__step ftill-stepper__step--${state}`} aria-current={state === "active" ? "step" : undefined}>
          <span className="ftill-stepper__dot">{state === "done" ? <CheckIcon /> : step}</span>
          <span className="ftill-stepper__label">{label}</span>
        </li>
      );
    })}
  </ol>
);

// Page frame shared by the Fashion open/close till screens: 56px white header
// with a back button, the screen title and "Till · Store" meta.
const FashionTillShell = ({ title, meta, onBack, backLabel = "Back to billing", step, children, testId }) => (
  <div className="ftill th-cw" data-testid={testId}>
    <header className="ftill-header">
      {onBack ? (
        <button type="button" className="ftill-iconbtn ftill-iconbtn--soft" aria-label={backLabel} onClick={onBack}>
          <BackIcon />
        </button>
      ) : null}
      <div className="ftill-header__text">
        <b className="ftill-header__title">{title}</b>
        {meta ? <span className="ftill-header__meta">{meta}</span> : null}
      </div>
      <div className="ftill-header__spacer" />
      {step ? <FashionTillStepper active={step} /> : null}
    </header>
    <div className="ftill-body">{children}</div>
  </div>
);

export default FashionTillShell;
